export default __webpack_public_path__ + "static/AssetMynd-flipped-cd403b51d06657d91d8b011b93a65091.png";